/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Payment_Method_Change_Bank_MatchedInputs */

const vi_error_payment_method_change_bank_matched = /** @type {(inputs: Error_Payment_Method_Change_Bank_MatchedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khoản này đến từ đối soát chuyển khoản (đã khớp với giao dịch trên sao kê ngân hàng) nên không đổi hình thức được.`)
};

/**

* @param {Error_Payment_Method_Change_Bank_MatchedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_payment_method_change_bank_matched = /** @type {((inputs?: Error_Payment_Method_Change_Bank_MatchedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Payment_Method_Change_Bank_MatchedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_payment_method_change_bank_matched(inputs)
});